import React from 'react';
import ConfirmModal from '../confirmationmodal/confirmationModal';
import { Delete } from '../icons';
import { useTranslation } from 'react-i18next';

export enum DeleteModalType {
  NO_TRANSACTION = 'NO_TRANSACTION',
  DELETABLE_TRANSACTION = 'DELETABLE_TRANSACTION',
  NOT_OPEN_TRANSACTION = 'NOT_OPEN_TRANSACTION',
}

interface WorkTimeDeleteModalProps {
  deleteModal: boolean;
  deleteModalType: DeleteModalType;
  handleCancelDelete: () => void;
  handleDeleteWithTransaction: () => void;
  handleDeleteWithoutTransaction: () => void;
}

const DeleteModalNoTransaction = ({
  visible,
  onCancel,
  onConfirm,
  t,
}: {
  visible: boolean;
  onCancel: () => void;
  onConfirm: () => void;
  t: (key: string) => string;
}) => (
  <ConfirmModal
    visible={visible}
    onClose={onCancel}
    title={t('worktime:deleteWorkTimeQuestion')}
    subtitle={t('worktime:deleteWorkTimeText')}
    icon={<Delete />}
    cancelText={t('common:cancel')}
    confirmText={t('common:delete')}
    onConfirm={onConfirm}
  />
);

const DeleteModalDeletableTransaction = ({
  visible,
  onCancel,
  onDeleteWithTransaction,
  onDeleteWithoutTransaction,
  t,
}: {
  visible: boolean;
  onCancel: () => void;
  onDeleteWithTransaction: () => void;
  onDeleteWithoutTransaction: () => void;
  t: (key: string) => string;
}) => (
  <ConfirmModal
    visible={visible}
    onClose={onCancel}
    title={t('worktime:deleteWorkTimeWithTransactionQuestion')}
    icon={<Delete />}
    cancelText={t('common:cancel')}
    confirmText={t('common:yes')}
    onConfirm={onDeleteWithTransaction}
    middleButtonText={t('common:no')}
    onMiddleButtonClick={onDeleteWithoutTransaction}
  />
);

const DeleteModalNotOpenTransaction = ({
  visible,
  onCancel,
  onConfirm,
  t,
}: {
  visible: boolean;
  onCancel: () => void;
  onConfirm: () => void;
  t: (key: string) => string;
}) => (
  <ConfirmModal
    visible={visible}
    onClose={onCancel}
    title={t('worktime:deleteWorkTimeTransactionNotOpenQuestion')}
    icon={<Delete />}
    cancelText={t('common:cancel')}
    confirmText={t('common:delete')}
    onConfirm={onConfirm}
  />
);

const WorkTimeDeleteModal: React.FC<WorkTimeDeleteModalProps> = ({
  deleteModal,
  deleteModalType,
  handleCancelDelete,
  handleDeleteWithTransaction,
  handleDeleteWithoutTransaction,
}) => {
  const { t } = useTranslation();
  const modalProps = {
    visible: deleteModal,
    onCancel: handleCancelDelete,
    t,
  };

  switch (deleteModalType) {
    case DeleteModalType.NO_TRANSACTION:
      return (
        <DeleteModalNoTransaction {...modalProps} onConfirm={handleDeleteWithoutTransaction} />
      );

    case DeleteModalType.DELETABLE_TRANSACTION:
      return (
        <DeleteModalDeletableTransaction
          {...modalProps}
          onDeleteWithTransaction={handleDeleteWithTransaction}
          onDeleteWithoutTransaction={handleDeleteWithoutTransaction}
        />
      );

    case DeleteModalType.NOT_OPEN_TRANSACTION:
      return (
        <DeleteModalNotOpenTransaction {...modalProps} onConfirm={handleDeleteWithoutTransaction} />
      );

    default:
      return null;
  }
};

export default WorkTimeDeleteModal;
